import './ButtonLink.scss'

const ButtonLink = (props) => {
   const classNames = `${props.className || ''} buttonlink`
   return (
      <button className={classNames} onClick={props.onClick}>{props.children}</button>
   );
}

export default ButtonLink;